import { groupBy } from "@/helpers/groupByHelper";
import { CharityContent, CharityResponse } from "../Content";

export class CharityConfig {
    charities: Charity[];
    constructor(content: CharityContent[], charities: CharityResponse[]) {
        this.charities = [];
        const charitiesByPrefix = groupBy(charities, "prefix");

        for (const key in charitiesByPrefix) {
            const resources = charitiesByPrefix[key] as CharityResponse[];
            const charityContent = content.find(c => c.resource_prefix === key);

            this.charities.push(new Charity(resources, charityContent));
        }
        
        this.charities.sort((a, b) => +(a.content?.order ?? "0") - +(b.content?.order ?? "0"));
    }
}

export class Charity {
    content?: CharityContent;
    resources: CharityResource[];
	
    constructor(resources: CharityResponse[], content?: CharityContent,) {
        this.content = content;
        this.resources = resources.map(r => new CharityResource(r));
    }
}

export class CharityResource {
    amount: number;
    identifier: string;
    prefix: string;
    resourceCode: string;

    constructor(resp: CharityResponse) {
        this.amount = resp.amount;
        this.identifier = resp.identifier;
        this.prefix = resp.prefix;
        this.resourceCode = resp.resourceCode;
    }
}